module.exports = __webpack_public_path__ + "static/img/minidisc.9619c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/minidisc.png
// module id = irer
// module chunks = 0